// extracted by mini-css-extract-plugin
export default {"icon":"CustomViewLead_icon__1acE6","field-icon":"CustomViewLead_field-icon__osexB","file-icon":"CustomViewLead_file-icon__q9EoB"};